import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { dark } from "@clerk/ui/themes";
import { esMX } from "@clerk/localizations";
import { useTheme } from "next-themes";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const localization = {
  ...esMX,
  signIn: {
    ...(esMX.signIn || {}),
    start: {
      ...((esMX.signIn || {}).start || {}),
      title: "Entrar a Mediana Hub",
      subtitle: "Usa tu correo @medianamag.com",
    },
  },
  signUp: {
    ...(esMX.signUp || {}),
    start: {
      ...((esMX.signUp || {}).start || {}),
      title: "Crear tu cuenta interna",
      subtitle: "Solo personal con correo @medianamag.com",
    },
  },
};

// Starts Clerk from the backend's runtime config, so deploy's live keys need no rebuild.
export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const { resolvedTheme } = useTheme();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const isDark = resolvedTheme === "dark";
  const appearance = {
    ...(isDark ? { theme: dark, captcha: { theme: "dark" } } : {}),
    variables: {
      colorPrimary: isDark ? "#B8A5FF" : "#C4B5FD",
      colorPrimaryForeground: "#0D0D0D",
      colorBackground: isDark ? "#1A1A1A" : "#FFFFFF",
      fontFamily: "'IBM Plex Sans', ui-sans-serif, system-ui",
      borderRadius: "0.55rem",
    },
  };

  if (unavailable)
    return <p style={{ padding: 24 }}>El inicio de sesión no está disponible ahora. Recarga la página para intentarlo de nuevo.</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      localization={localization}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
